import { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

export default class TableSortHeaderCell extends Component {
  static propTypes = {
    keyName: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    order: PropTypes.string,
    orderBy: PropTypes.string,
    tooltipTitle: PropTypes.string,
    align: PropTypes.string,
    orderByHandler: PropTypes.string,
    orderHandler: PropTypes.string,
    colSpan: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    align: 'inherit',
    orderByHandler: 'orderBy',
    orderHandler: 'orderDesc',
    colSpan: 1,
    width: 'auto',
  };

  render() {
    return (
      <TableCell
        className={this.props.className}
        key={this.props.keyName}
        align={this.props.align}
        colSpan={this.props.colSpan}
        style={{ width: this.props.width }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{this.props.title}</Typography>
      </TableCell>
    );
  }
}
